import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import i18n from './utils/index'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// import '../src/assets/style/baseStyle.scss';
Vue.prototype.$baseUrl = 'http://192.168.0.248:8809/';
import MetaInfo from 'vue-meta-info';
Vue.use(MetaInfo)
// 引入适配的flexible
import "./utils/flexible.js"
Vue.config.productionTip = false
Vue.use(Antd);
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  mounted(){
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
